import React, { Component } from "react";
import { Link } from "react-router-dom";
import Header from "../../Components/MainLayout/Header";
import { connect } from "react-redux";
import Skeleton from "react-loading-skeleton";
import { withRouter } from "react-router-dom";
import axios from "axios";

const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});

class Payments extends Component {
  state = { exam: [], loading: false, fakeData: [1, 2] };

  componentDidMount() {
    this.fetchfee({
      session: this.props.user.session.id,
      for_class: this.props.match.params.classs,
      exam_system_type: this.props.match.params.typeid,
    });
  }

  fetchfee = (params = {}) => {
    this.setState({ loading: true });
    axios
      .get(`/api/exams`, {
        params: { ...params },
      })
      .then((res) => {
        this.setState({ exam: res.data, loading: false });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };
  render() {
    const { classs, classname, section, sectionname, typeid, typename } =
      this.props.match.params;
    return (
      <div>
        <Header
          to="/home"
          title={`${this.props.match.params.classname}-${this.props.match.params.sectionname}-${this.props.match.params.typename}`}
        />
        {this.state.loading ? (
          <div className="container pt-3">
            {this.state.fakeData?.map((item, index) => {
              return (
                <div className="d-flex flex-wrap">
                  {this.state.fakeData?.map((item, index) => {
                    return (
                      <div key={index} className="col-6 px-1">
                        <div className="btn mt-2 border rounded btn-block p-1">
                          <Skeleton />
                        </div>
                      </div>
                    );
                  })}
                </div>
              );
            })}
          </div>
        ) : (
          <div className="container pt-3 pb-5">
            <p className="th-14 th-bold mb-2">Subjects</p>
            {this.state.exam.length === 0 ? (
              <p className="th-12 text-center py-5">No Subjects for Now.</p>
            ) : (
              <div className="row p-2">
                {this.state.exam?.map((item, index) => {
                  return (
                    <div className="col-6 px-1" key={index}>
                      <Link
                        type="button"
                        className="btn mt-2 th-att-btn btn-block"
                        to={`/addstudentsmarks/${classs}/${classname}/${section}/${sectionname}/${typeid}/${typename}/${item.id}/${item.exam_system_subject.subject.id}`}
                      >
                        {item.exam_system_subject.subject.subject}
                      </Link>
                    </div>
                  );
                })}
              </div>
            )}
            <div className="py-3"></div>
          </div>
        )}
      </div>
    );
  }
}
export default withRouter(connect(mapStateToProps)(Payments));
